import { ArrowLeftRight } from 'lucide-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store';
import { useTranslate } from '~/hooks/useTranslate.ts';
import { csrfHeaders } from '~/lib/csrf';

export default function UserProfile() {
  const [showPopOver, setShowPopOver] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const { t } = useTranslate();

  async function handleLogout() {
    setLoggingOut(true);

    const res = await fetch('/auth/logout', {
      method: 'POST',
      credentials: 'include',
      headers: {
        ...csrfHeaders(),
        'Content-Type': 'application/json',
      },
    });

    const data = await res.json();

    window.location.assign(data.redirectUrl);
  }

  const user = useSelector((state: RootState) => state.auth.user);
  const firstName = user?.firstName;
  const lastName = user?.lastName;
  const role = user?.role;

  const initials =
    `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();

  return (
    <div className="p-4 border-t border-neut-border relative mt-auto">
      <button
        onClick={() => setShowPopOver((prev: boolean) => !prev)}
        className="flex items-center gap-3 cursor-pointer w-full"
      >
        <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center text-white font-medium bg-gradient-to-br from-prim to-prim-hover ">
          {initials}
        </div>
        <div className="flex-1 text-left">
          <p className="text-sm font-medium text-neut-prim capitalize">{`${firstName} ${lastName}`}</p>
          <p className="text-xs font-normal text-neut-sec capitalize">
            {role?.toLowerCase()} Account
          </p>
        </div>
      </button>

      <div
        style={{ display: showPopOver ? 'block' : 'none' }}
        className={`absolute bottom-full left-4 right-4 mb-2 bg-neut-bg-alt border border-neut-border rounded-lg shadow-lg p-2`}
      >
        <button
          onClick={handleLogout}
          className="w-full text-left px-3 py-2 text-sm text-neut-prim hover:bg-neut-hover rounded-lg transition-colors font-medium flex items-center gap-2 cursor-pointer"
        >
          <ArrowLeftRight size={16} />
          <div className="flex-1">
            {loggingOut ? t('auth.logout.in-progress') : t('auth.logout')}
          </div>
        </button>
      </div>
    </div>
  );
}
